import {
  type TableSelection,
  TableSelectionNotice,
} from "@components/ui-kit/table";
import cx from "classnames";
import { map } from "lodash";
import { observer } from "mobx-react-lite";
import React from "react";
import s from "./CollapsibleTableBody.module.css";

export const CollapsibleTableBody = observer(function CollapsibleTableBody<
  TSubrow,
>({
  selection,
  table,
  subRows,
}: {
  table: any;
  selection?: TableSelection;
  subRows: (row: TSubrow) => void;
}) {
  return (
    <div className={cx(s.tableWrapper)}>
      <table className={cx(table.props.className, s.table)}>
        <thead>
          <tr>
            {map(table.header.cells, (h) => (
              <th {...h.props}>{h.render()}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {selection?.meta.someSelected && (
            <tr>
              <td colSpan={table.header.cells.length}>
                <TableSelectionNotice selection={selection} />
              </td>
            </tr>
          )}
          {map(table.rows, (row) => (
            <React.Fragment>
              <tr
                {...row.props}
                className={cx({ [s.tableRowPinned]: row.row.isPinned })}
              >
                {map(row.cells, (cell) => (
                  <td {...cell.props}>{cell.render()}</td>
                ))}
              </tr>
              {row.row.isOpen && subRows(row)}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
});
